// channels/hooks/useChannelsData.js

import { useEffect, useState, useCallback } from "react";
import { Channels } from "../../../services/api/channels/utils/list";
import use123zapStore from "../../../context/123zapStore";
import { useAuth } from "../../../app/providers/AuthProvider";

export function useChannelsData() {
  const { isAuthenticated } = useAuth();

  const channels = use123zapStore((s) => s.channels);
  const setChannels = use123zapStore((s) => s.setChannels);
  const alreadyFetch = use123zapStore((s) => s.alreadyFetchChannels);
  const setAlreadyFetch = use123zapStore((s) => s.setAlreadyFetchChannels);

  const [loading, setLoading] = useState(!alreadyFetch);
  const [isFetching, setIsFetching] = useState(false);

  /**
   * Busca canais da API
   */
  const fetchChannels = useCallback(
    async ({ silent = false } = {}) => {
      try {
        if (silent) {
          setIsFetching(true);
        } else {
          setLoading(true);
        }

        const response = await Channels();

        setChannels(response.channels || []);
        setAlreadyFetch(true);
      } catch (error) {
        console.error("Erro ao carregar canais:", error);
      } finally {
        setLoading(false);
        setIsFetching(false);
      }
    },
    [setChannels, setAlreadyFetch]
  );

  /**
   * Carregamento inicial
   * Só executa se:
   * - Usuário estiver autenticado
   * - Ainda não tiver buscado canais
   */
  useEffect(() => {
    if (!isAuthenticated || alreadyFetch) return;

    fetchChannels();
  }, [isAuthenticated, alreadyFetch, fetchChannels]);

  return {
    channels,
    loading,
    isFetching,
    refetch: () => fetchChannels({ silent: true }),
  };
}